import React from 'react';
import { useGlobalContext } from '@honeycomb/data';
import { P195Leaderboard } from './P195Leaderboard';
const leaderboardElementIds = ['div-gpt-ad-1934534-16', 'div-gpt-ad-1934534-17'];
export function HotelSearchResultsSlot({ index, hotels }) {
    var _a, _b, _c, _d, _e;
    const { configSettings: { Platform195EnabledPages, Platform195AdvertPlacement }, } = useGlobalContext();
    const isPlatform195Enabled = (_a = Platform195EnabledPages === null || Platform195EnabledPages === void 0 ? void 0 : Platform195EnabledPages.split('|')) === null || _a === void 0 ? void 0 : _a.includes('hotelsearchresults');
    if (!isPlatform195Enabled) {
        return null;
    }
    const validHotels = hotels.filter((h) => !!h.hotel);
    // Get where the leaderboard ads should go
    const leaderboardDisplayIndexes = ((_e = (_d = (_c = (_b = Platform195AdvertPlacement === null || Platform195AdvertPlacement === void 0 ? void 0 : Platform195AdvertPlacement.split(',')) === null || _b === void 0 ? void 0 : _b.filter((el) => Number.isFinite(Number(el)))) === null || _c === void 0 ? void 0 : _c.slice(0, 2)) === null || _d === void 0 ? void 0 : _d.map((ml) => Number(ml))) === null || _e === void 0 ? void 0 : _e.sort((a, b) => a - b)) || [1, 3];
    const largestValidIndex = Math.max(0, ...leaderboardDisplayIndexes.filter((idx) => idx <= validHotels.length - 1));
    const leaderboardDisplayIds = leaderboardDisplayIndexes.map((el, idx) => ({
        index: el,
        div: leaderboardElementIds[idx],
    }));
    const hotelLeaderboard = leaderboardDisplayIds.find((el) => Number(el.index) === index && el.div);
    if (!hotelLeaderboard)
        return null;
    return (React.createElement(P195Leaderboard, { displayId: hotelLeaderboard.div, isLast: index === largestValidIndex, key: hotelLeaderboard.div }));
}
